import script from "./holeOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./holeOverview.vue?vue&type=script&setup=true&lang=js"

import "./holeOverview.vue?vue&type=style&index=0&id=64d81a33&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64d81a33"]])

export default __exports__